export const GET_WRITE_OFFS_PENDING = 'GET_WRITE_OFFS_PENDING'
export const GET_WRITE_OFFS_SUCCESS = 'GET_WRITE_OFFS_SUCCESS'
export const GET_WRITE_OFFS_FAILED = 'GET_WRITE_OFFS_FAILED'
